// extracted by mini-css-extract-plugin
export var cardHeader = "_j3-0";
export var reorderHandle = "_j3-3";
export var titleArea = "_j3-1";
export var titleAreaWithHandle = "_j3-2";